import { Analytics } from "@vercel/analytics/react";

import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import { Perf } from "r3f-perf";
import { StrictMode, Suspense } from "react";

import Loader from "./Components/Loader.jsx";
import App from "./App.jsx";
import "./index.css";

console.log("Hi if you notice a bug please contact me");

const isMobile = () => {
  return window.innerWidth <= 1000 && window.innerHeight <= 800;
};

const root = ReactDOM.createRoot(document.querySelector("#root"));

const fovForMobile = 100;
const fovForPc = 45;

root.render(
  <StrictMode>
    <Canvas
      camera={{
        fov: isMobile() ? fovForMobile : fovForPc,
        near: 0.1,
        far: 200,
        position: [52, 7, 12],
      }}
    >
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>

      {/*<Perf position="top-left" />*/}
    </Canvas>

    <Analytics />
    <div style={{ display: "none" }}>
      <section aria-hidden="true">
        <h1>Happii Home - Mr and Mrs Poka</h1>
        <h2></h2>
        <h2></h2>
        <h2></h2>
      </section>
      <section aria-hidden="true">
        <h2></h2>
        <ul>
          <li>Love Youu</li>
        </ul>
      </section>
      <section aria-hidden="true">
        <p>This website is best experienced with JavaScript enabled.</p>
      </section>
      <noscript>
        <p>This website requires JavaScript to be enabled in your browser.</p>
      </noscript>
    </div>
  </StrictMode>
);
